let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5l2C3")).then(() => parcelRequire('3Ba1h'));